<template>
  <div class="app-breadcrumb">
    <b-breadcrumb v-if="breadcrumbItems" :items="breadcrumbItems" />
    <b-breadcrumb v-else>
      <slot></slot>
    </b-breadcrumb>
  </div>
</template>

<script>
export default {
  name: 'app-breadcrumb',
  props: {
    'breadcrumb-items': {
      type: Array,
    },
    color: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.app-breadcrumb {
  .breadcrumb {
    background-color: transparent;
    margin: 0;
    padding: 0;
    .breadcrumb-item {
      font-size: .75rem;
      font-weight: 600;
      text-transform: uppercase;
      line-height: 1;
      opacity: .75;
      &:not(:last-child) {
        margin-bottom: .75rem;
        &:after{
          content: '';
          background-image: url('@img/breadcrumb/chevron.svg');
          width: 5px;
          height: 100%;
          background-position: center;
          background-repeat: no-repeat;
          background-size: contain;
          line-height: 0;
          float: none;
          display: inline-block;
          vertical-align: top;
          margin-left: .75rem;
          margin-right: .75rem;
        }
      }
      & + .breadcrumb-item {
        padding-left: 0;
        &:before{
          display: none;
        }
      }
      &.active {
        color: #363636;
        font-weight: 400;
        opacity: 1;
      }
    }
  }
}

@include media-breakpoint-up(lg) {
  .app-breadcrumb {
    .breadcrumb {
      .breadcrumb-item {
        font-size: .875rem;
        &:not(:last-child):after{
          width: 8px;
          height: 100%;
        }
      }
    }
  }
}
</style>
